import React from 'react'
import { transformDateToString } from './transformDateToString'
import { addYears } from 'date-fns'

export const nextYearDate = () => {
	return transformDateToString(addYears(new Date(), 1))
}
